import { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useClickstream, useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import useTimeout from '@zenbusiness/application-commons-hooks/useTimeout';
import PageLoading from '@zenbusiness/zui/PageLoading';

const Logout = () => {
  const { logout } = useAuthentication();
  const [searchParams] = useSearchParams({ redirectTo: '/' });

  const handleLogoutCompleted = useClickstreamCallback('logoutCompleted', null, { pick: [] });
  const handleUserUnidentified = useClickstreamCallback('userUnidentified', null, { pick: [] });

  const { isAvoInitialized } = useClickstream();
  const [avoTimedOut, setAvoTimedOut] = useState(false);
  const timeout = useTimeout(() => setAvoTimedOut(true));
  useEffect(() => {
    // Set a timeout of 1 second to allow for avo initialization before proceeding with logout
    timeout.set(1000);
  }, [timeout]);

  useEffect(() => {
    if (!isAvoInitialized && !avoTimedOut) {
      return;
    }
    const redirectTo = searchParams.get('redirectTo');
    if (isAvoInitialized) {
      handleLogoutCompleted();
      handleUserUnidentified();
    }
    logout(redirectTo);

    // NOTE: Disabling exhaustive-deps because we only want to run this once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAvoInitialized, avoTimedOut]);

  return <PageLoading />;
};

export default Logout;
